<div class="modal-header" appCustomAutofocus>
    <h3>Add Attachments</h3>
    <span *ngIf="lastSave.status === 'success' && lastSave.time != null" class="badge badge-success default" [ngClass]="{fade: formData.labelFade}" style="margin-left:10;margin-top:25px;position: fixed;display:table;height: 15px;">Save Successful - {{lastSave.time}}</span>
    <span *ngIf="lastSave.status !== 'success' && lastSave.time != null" class="badge badge-danger default" [ngClass]="{fade: formData.labelFade}" style="margin-left:10px;margin-top:25px;display:table;height: 15px;">Save Fail - {{lastSave.time}}</span>
</div>
<div class="modal-body">
    <div class="col-md-12" *ngIf="alert != null">
        <div class="alert" [ngClass]="{'alert-success' : alert.type === 'success', 'alert-default' : alert.type === 'default', 'alert-danger': alert.type === 'danger' }" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>
    <label><strong>Attachments</strong></label>
    <div *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
        <div class="row" *ngIf="moduleID == 38">
            <div class="col-lg-5" style="word-break: break-all;">
                <a href="/Employee/GetFileAttachmentData?fileAttachmentID={{file.FileAttachmentID}}"> {{file.AttachmentFileName}}</a>
            </div>
            <div class="col-lg-5">
                <input type="text" class="form-control" [(ngModel)]="file.AttachmentCaption" (blur)="checkCaption()" placeholder="type a caption here..." />
            </div>
            <div class="col-lg-1">
                <button class="btn btn-danger btn-icon-only" (click)="deleteSavedAttachment(file)" *ngIf="active">
                    <i class="modus-icons">close</i>
                </button>
            </div>
        </div>
    </div>
    <label *ngIf="newFiles.length > 0" style="padding-left: 5px;"><strong>pending save</strong></label>
    <br *ngIf="newFiles.length > 0" />
    <div *ngFor="let file of newFiles" style="margin-top: 20px;word-break: break-all;">
        {{file.Filename}}
        <button class="btn btn-danger btn-icon-only" (click)="deleteUnsavedAttachment(file)" *ngIf="file.File != null && file.Progress == null">
            <i class="modus-icons">close</i>
        </button>
        <div style="padding-left:15px;margin-top:5px;">
            <div class="progress" style="width:250px;" *ngIf="file.Progress > 0">
                <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
            </div>
        </div>
    </div>
    <div style="cursor:pointer;"
         ngfDrop
         multiple="1"
         selectable="1"
         [(validDrag)]="validComboDrag"
         [(files)]="formData.fileDrop"
         accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
         [(dragFiles)]="dragFiles"
         class="drop-box"
         [class.invalid-drag]="validComboDrag===false"
         [class.valid-drag]="validComboDrag"
         (filesChange)="upload()" [ngfFixOrientation]="false"
         *ngIf="((newFiles.length == 0 && savedFiles.length == 1) || (newFiles.length == 1 && savedFiles.length == 0) || (newFiles.length == 0 && savedFiles.length == 0)) && active">
        Drop a file or Click to upload
    </div>
    <div *ngIf="!(((newFiles.length == 0 && savedFiles.length == 1) || (newFiles.length == 1 && savedFiles.length == 0) || (newFiles.length == 0 && savedFiles.length == 0)))">
        <div class="alert alert-info">Maximum of 2 attachments</div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary"
            (click)="saveClicked()"
            *ngIf="!status"
            [disabled]="(newFiles.length < 1 && !captionChanged) || formData.disableButton">
        Save
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>